module.exports = __webpack_public_path__ + "static/media/new-york-65.a2133e6d.jpg";